import { useCallback } from 'react';

type FileType = 'csv' | 'json' | 'python' | 'txt';

export const formatDateForFilename = (date: Date): string => {
  const pad = (n: number) => n.toString().padStart(2, '0');
  return `${date.getFullYear().toString().slice(-2)}${pad(date.getMonth() + 1)}${pad(date.getDate())}_${pad(date.getHours())}${pad(date.getMinutes())}${pad(date.getSeconds())}`;
};

const getMimeType = (fileType: FileType): string => {
  const types: Record<FileType, string> = {
    csv: 'text/csv;charset=utf-8;',
    txt: 'text/txt;charset=utf-8;',
    json: 'application/json;charset=utf-8;',
    python: 'text/plain;charset=utf-8;'
  };
  return types[fileType];
};

const useDownloadFileContent = (capturePosthogEvent: () => void) => {
  const downloadFileContent = useCallback(
    (fileContent: string | undefined, fileType: FileType): void => {
      if (!fileContent) return;

      const timestamp = formatDateForFilename(new Date());
      const mimeType = getMimeType(fileType);
      const extension = fileType === 'python' ? 'py' : fileType;

      const blob = new Blob([fileContent], { type: mimeType });
      const url = URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.download = `GX-Data_${timestamp}.${extension}`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      if (typeof URL.revokeObjectURL === 'function') {
        setTimeout(() => {
          URL.revokeObjectURL(url);
        }, 0);
      }

      capturePosthogEvent();
    },
    [capturePosthogEvent]
  );

  return {
    downloadFileContent
  };
};

export default useDownloadFileContent;
